// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-column-clustered';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.576 16.344h16.848M14.04 9v7.344h3.384V9a.568.568 0 0 0-.576-.576h-2.232A.568.568 0 0 0 14.04 9zM4.32 9v7.344h3.384V9a.568.568 0 0 0-.576-.576H4.896A.568.568 0 0 0 4.32 9z' />
    <path
      fill='currentColor'
      d='M10.296 2.304v14.04h3.384V2.232a.568.568 0 0 0-.576-.576h-2.232c-.288 0-.504.288-.576.648zM.576 5.688v10.656H3.96V5.616a.568.568 0 0 0-.576-.576H1.152c-.288 0-.576.288-.576.648z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
